import { joinClasses } from 'utils/joinClasses'
import { Typography } from '@frontend/design_system'
import { StatusBadgeProps } from './types'
import styles from './styles.module.scss'

export const StatusBadge = ({
  status = 'ok',
  label,
  height,
  typographyName = 'Subtitle3',
  color = 'whiteMaster',
}: StatusBadgeProps) => (
  <Typography
    className={joinClasses(styles.badge, styles[status])}
    Tag="div"
    name={typographyName}
    style={{ height }}
    color={color}
  >
    {label}
  </Typography>
)
